import React from 'react';
//import { Card, Card.Header, Card.Title, Card.Body } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line, AreaChart, Area } from 'recharts';
import { Clock, Target, Award, Calendar, TrendingUp, Users } from 'lucide-react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';



import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
} from 'recharts';

const sampleData = {
    areaStats: [
        { area: 'Personal', totalHours: 45, taskCount: 15, completionRate: 80 },
        { area: 'Professional', totalHours: 55, taskCount: 12, completionRate: 75 },
    ],
    timeDistribution: [
        { date: 'Mon', personal: 8, professional: 10 },
        { date: 'Tue', personal: 7, professional: 11 },
        { date: 'Wed', personal: 9, professional: 9 },
        { date: 'Thu', personal: 6, professional: 12 },
        { date: 'Fri', personal: 8, professional: 8 },
    ],
};

const COLORS = ['#f4af36', '#00C49F'];



const BehaviouralInsightDashboard: React.FC = () => {

    const { t } = useTranslation();
    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Analytics.page_title'),
            url: '/analytics'
        },
        {
            label: t('BehaviouralInsightDashboard.page_title'),
            active: true
        }
    ];


    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />

            <div className="mt-3">
                {/* Metriche principali */}

                <h2 className="mb-0">Life Balance Dashboard</h2>



                <Row className="p-2">
                    <Col md={4}>
                        <Card>
                            <Card.Body className="pt-3">
                                <div className="d-flex flex-column ">

                                    <p className="fs-8">Personal</p>
                                    <p className="fs-7 fw-bold">7 giorni</p>
                                    <div className="d-flex align-items-center gap-2 mt-1 mb-1">
                                        <p className="m-0">Total Hours: {sampleData.areaStats[0].totalHours}</p>
                                        <Clock className="w-16 h-16 text-primary" />
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mt-1 mb-1">
                                        <p className="m-0">Tasks: {sampleData.areaStats[0].taskCount}</p>
                                        <Calendar className="h-16 w-16 text-primary" />
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mt-1 mb-1">
                                        <p className="m-0">Completion Rate: {sampleData.areaStats[0].completionRate}%</p>
                                        <Target className="h-16 w-16 text-primary" />
                                    </div>

                                    {/*<Award className="h-8 w-8 text-primary" /> */}

                                </div>
                            </Card.Body>
                        </Card>

                        <Card className='mt-2'>
                            <Card.Body className="pt-3">
                                <div className="d-flex flex-column ">

                                    <p className="fs-8">Professional </p>
                                    <p className="fs-7 fw-bold">7 giorni</p>
                                    <div className="d-flex align-items-center gap-2 mt-1 mb-1">
                                        <p className="m-0">Total Hours: {sampleData.areaStats[1].totalHours}</p>
                                        <Clock className="w-16 h-16 text-primary" />
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mt-1 mb-1">
                                        <p className="m-0">Tasks: {sampleData.areaStats[1].taskCount}</p>
                                        <Calendar className="h-16 w-16 text-primary" />
                                    </div>
                                    <div className="d-flex align-items-center gap-2 mt-1 mb-1">
                                        <p className="m-0">Completion Rate: {sampleData.areaStats[1].completionRate}%</p>
                                        <Target className="h-16 w-16 text-primary" />
                                    </div>

                                    {/*<Award className="h-8 w-8 text-primary" /> */}

                                </div>
                            </Card.Body>
                        </Card>

                    </Col>

                    <Col md={8}>
                        <Card>
                            <Card.Header className="pt-3 ps-3 pb-0">
                                <Card.Title className="d-flex align-items-center gap-2">
                                    <Users className="w-5 h-5" />
                                    Total Hours Distribution
                                </Card.Title>
                            </Card.Header>
                            <Card.Body className="pb-0">
                                {/* Total Hours Distribution */}
                                <div className="chart-container">

                                    <ResponsiveContainer width="100%" height={350}>
                                        <PieChart>
                                            <Pie
                                                data={sampleData.areaStats}
                                                dataKey="totalHours"
                                                nameKey="area"
                                                cx="50%"
                                                cy="50%"
                                                outerRadius={80}
                                                label
                                            >
                                                {sampleData.areaStats.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS[index]} />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                            <Legend />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>

                </Row>

                <Card className='mt-3 mb-3 border border-light rounded-5' >
                    <Card.Body>
                        {/* Time Distribution Chart */}
                        <div className="chart-container">
                            <h3>Weekly Time Distribution</h3>
                            <p className="text-700">Paid and Verified for each piece of content</p>
                            <ResponsiveContainer width="100%" height={300}>
                                <BarChart data={sampleData.timeDistribution}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="date" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="personal" fill={COLORS[0]} name="Personal" />
                                    <Bar dataKey="professional" fill={COLORS[1]} name="Professional" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </Card.Body>
                </Card>

            </div>
        </>
    );
};

export default BehaviouralInsightDashboard;
